export const LANDING = "/";
export const PROJECTS = "/projects";
export const PROJECT_DETAILPAGE = "/project/:title";
export const CONTACT = "/contact";
